import './Avatar.scss'

export const Avatar = ({name, onClick}) => {
    return (
        <div className="avatar" onClick={onClick} data-clickable={onClick ? 'true' : 'false'}>
            <span className={'avatar-initial'}>{name?.charAt(0)}</span>
        </div>
    )
}